import { slicedToArray as _slicedToArray } from '../_virtual/_rollupPluginBabelHelpers.js';

var getQueryParam = function getQueryParam(param) {
  var _window;
  if (typeof ((_window = window) === null || _window === void 0 || (_window = _window.location) === null || _window === void 0 ? void 0 : _window.search) !== 'undefined') {
    var query = window.location.search.substring(1);
    var vars = query.split('&');
    return vars.find(function (variable) {
      var _variable$split = variable.split('='),
        _variable$split2 = _slicedToArray(_variable$split, 2),
        key = _variable$split2[0],
        value = _variable$split2[1];
      if (decodeURIComponent(key) == param) {
        return decodeURIComponent(value);
      }
    });
  }
};

export { getQueryParam };
//# sourceMappingURL=queryString.js.map
